import React from 'react';
import './Footer.css';

const Footer = ({ projectCount, totalSkills, totalMedia }) => {
  const currentYear = new Date().getFullYear();
  const metrics = [
    `${String(projectCount).padStart(2, '0')} projects`,
    `${String(totalSkills).padStart(2, '0')} skills`,
    `${String(totalMedia).padStart(2, '0')} media items`,
  ];

  return (
    <footer className="footer">
      <div className="footer-copy">
        <p className="footer-title">Alexandre Nunes</p>
        <p className="footer-text">
          Portfolio built around systems, signals and creative experimentation.
        </p>
      </div>

      <div className="footer-metrics" aria-label="Portfolio metrics">
        {metrics.map((metric) => (
          <span key={metric}>{metric}</span>
        ))}
      </div>

      <nav className="footer-links" aria-label="Footer navigation">
        <a href="#top">Top</a>
        <a href="#projects">Work</a>
        <a href="#goals">Goals</a>
      </nav>

      <p className="footer-legal">© {currentYear}</p>
    </footer>
  );
};

export default Footer;
